export default "{\n  navigation {\n    identifier\n    dyCampaign {\n      variationId\n      decisionId\n    }\n  }\n}\n"